/**
 * Resolve link count for draft listing rows.
 * Listing should return a numeric count; this handles legacy full JSON payloads safely.
 */
export function getDraftLinksCount(row) {
  if (row == null) return 0;

  if (typeof row.links_count === "number" && Number.isFinite(row.links_count)) {
    return row.links_count;
  }

  const links = row.links;
  if (typeof links === "number" && Number.isFinite(links)) {
    return links;
  }

  if (typeof links !== "string") {
    return 0;
  }

  const trimmed = links.trim();
  if (!trimmed) return 0;
  if (/^\d+$/.test(trimmed)) return Number(trimmed);

  try {
    const parsed = JSON.parse(trimmed);
    return Array.isArray(parsed) ? parsed.length : 0;
  } catch {
    return 0;
  }
}
